// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".activity{gap:8px;max-width:calc(50% - 20px);flex:1 0 auto}@media(max-width:900px){.activity{max-width:100%}}.a-title{font-size:18px;justify-content:space-between}a.time{font-size:16px}.card-disabled{pointer-events:none;cursor:not-allowed;background:#ccc;opacity:.6}", ""]);
// Exports
module.exports = exports;
